export default function updateUserCognitoNormalizer(userProfile = {}) {
    return [
        {
            attributeName: 'name',
            attributeValue: userProfile.name
          },
          {
            attributeName: 'family_name',
            attributeValue: userProfile.familyName
          },
          {
            attributeName: 'phone_number',
            attributeValue: userProfile.phoneNumber.replace(/[^\d.+]/g, '')
          },
          {
            attributeName: 'email',
            attributeValue: userProfile.email
          },
          {
            attributeName: 'custom:iban',
            attributeValue: userProfile.iban
          },
          {
            attributeName: 'birthdate',
            attributeValue: userProfile.birthdate
          },
          {
            attributeName: 'custom:country',
            attributeValue: userProfile.country
          },
          {
            attributeName: 'custom:city',
            attributeValue: userProfile.city
          },
          {
            attributeName: 'custom:postal_code',
            attributeValue: userProfile.postalCode
          },
          {
            attributeName: 'custom:disable_tips_sms',
            attributeValue: userProfile.tipsSmsDisabled
          },
          {
            attributeName: 'address',
            attributeValue: userProfile.address
          },
          {
            attributeName: 'custom:motivation',
            attributeValue: userProfile.motivation
          },
          {
            attributeName: 'custom:nick_name',
            attributeValue: userProfile.nickName
          },
          {
            attributeName: 'custom:send_email_enabled',
            attributeValue: userProfile.isSendEmailEnabled
          },
          {
            attributeName: 'custom:mitarbeiterId',
            attributeValue: userProfile.mitarbeiterid
          },
          {
            attributeName: 'custom:disable_transfer',
            attributeValue: userProfile.disableIbanTransfer
          },
          {
            attributeName: 'custom:chk-payout-threshold',
            attributeValue: userProfile.checkPayoutThreshold
          },
          {
            attributeName: 'custom:payout_psp',
            attributeValue: userProfile.payoutPsp
          },
    ]
}